import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export default styled(Row)`
  align-items: center;
  justify-content: space-between;
  flex-shrink: 1;
`;
